const GOOGLE_ANALYTICS_ID = 'G-G2ECRGM33F';
const GOOGLE_TAG_SRC = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS_ID}`;
const VUTURE_TRACKER_SRC = 'https://ccsb.vuture.net/security/tracker.gif';

let googleAnalyticsLoaded = false;
let vutureTrackerLoaded = false;

function getCookie(name) {
	const cookie = document.cookie
		.split('; ')
		.find((row) => row.startsWith(`${name}=`));

	if (!cookie) {
		return null;
	}

	return decodeURIComponent(cookie.split('=').slice(1).join('='));
}

function getStoredConsent() {
	const storedConsent = getCookie('craft-cookie-banner');

	if (!storedConsent) {
		return null;
	}

	try {
		return JSON.parse(storedConsent);
	} catch (error) {
		console.warn('Unable to parse stored cookie consent.', error);
		return null;
	}
}

function loadGoogleAnalytics() {
	if (
		googleAnalyticsLoaded
		|| typeof window.gtag !== 'function'
		|| document.querySelector(`script[src="${GOOGLE_TAG_SRC}"]`)
	) {
		return;
	}

	googleAnalyticsLoaded = true;

	const script = document.createElement('script');
	script.async = true;
	script.src = GOOGLE_TAG_SRC;

	document.head.appendChild(script);

	window.gtag('js', new Date());
	window.gtag('config', GOOGLE_ANALYTICS_ID);
}

function loadVutureTracker() {
	if (vutureTrackerLoaded) {
		return;
	}

	vutureTrackerLoaded = true;

	const tracker = new Image();
	const params = new URLSearchParams({
		referer: document.referrer,
	});

	tracker.src = `${VUTURE_TRACKER_SRC}?${params.toString()}`;
}

function hasAnalyticalConsent(consent) {
	return Boolean(consent?.analyticalCookies);
}

function hasMarketingConsent(consent) {
	return Boolean(consent?.marketingCookies);
}

function handleConsent(event) {
	if (window.ccsbGpcActive) {
		return;
	}

	const consent = event.detail?.consent;

	if (hasAnalyticalConsent(consent)) {
		loadGoogleAnalytics();
	}

	if (hasMarketingConsent(consent)) {
		loadVutureTracker();
	}
}

document.addEventListener('cookie-banner:consent-onload', handleConsent);
document.addEventListener('cookie-banner:consent-update', handleConsent);

handleConsent({ detail: { consent: getStoredConsent() } });
